<template>
  <div>
    <search-nav @handleSearch="handleSearch">
      <!-- 부서명 (직영사업장 목록과 동일한 선택지, 사업장 meta.com_name 기준 검색) -->
      <search-select-company-name v-model="companyName" @input="handleSearch" />
      <div class="search-base search-container">
        <search-label-body label="연도">
          <div>
            <vs-select class="w-full xl:w-48" autocomplete v-model="targetYear">
              <vs-select-item v-for="year in totalYear" :key="year" :text="year" :value="year" />
            </vs-select>
          </div>
        </search-label-body>
      </div>
      <search-keyword label="키워드" v-model="keyword" @enter="handleSearch" />
    </search-nav>
  </div>
</template>

<script>
import SearchNav from "@/components/nav/SearchNav.vue";
import SearchLabelBody from "@/views/list/components/base/SearchLabelBody.vue";
import SearchSelectCompanyName from "@/views/list/components/SearchSelectCompanyName.vue";
import SearchKeyword from "@/views/list/components/SearchKeyword.vue";

export default {
  components: { SearchNav, SearchLabelBody, SearchSelectCompanyName, SearchKeyword },
  data () {
    return {
      companyName: '', // 부서명
      keyword: '',
      targetYear: '전체', // 초기 상태는 "전체" 선택 (검색 시 조건 없음으로 처리)
      totalYear: [],
    }
  },
  computed: {
    projectId () {
      return this.$route.params.proj_id
    },
    fieldCode () {
      return this.$route.params.fieldCode
    },
    fieldId () {
      return this.$route.params.fieldId
    },
  },
  mounted() {
    this.getTotalYear();
  },
  methods: {
    // 작업일 필터링된 년도를 불러옵니다.
    async getTotalYear() {
      const projectId = this.projectId;
      const code = this.fieldCode;
      const page = 1;
      const perPage = Number.MAX_SAFE_INTEGER;

      const options = { projectId, code, page, perPage }
      // 목록(FieldsList)과 store(fieldListInfo)를 공유하므로, dispatch 결과값을 우선 사용한다.
      const fieldListInfo = (await this.$store.dispatch("project/LOAD_FIELD_LIST", options)) || this.$store.state.project.fieldListInfo;
      const list = fieldListInfo && Array.isArray(fieldListInfo.data) ? fieldListInfo.data : [];
      const result = [...new Set(list.reduce((acc, item) => {
        const years = this.getYearRange(item.work_begin_at, item.work_end_at);
        acc.push(...years);
        return acc;
      }, []))].sort((a, b) => a - b);
      result.unshift("전체");
      this.totalYear = result;
    },

    // 시작일과 종료일 사이의 연도를 구합니다.
    getYearRange(beginDate, endDate) {
      if (!beginDate || !endDate) {
        return [];
      }

      const startYear = new Date(beginDate).getFullYear();
      const endYear = new Date(endDate).getFullYear();
      const years = [];

      for (let year = startYear; year <= endYear; year++) {
        years.push(year);
      }

      return years;
    },

    // "검색" 버튼이 클릭됐을 때 (부서명 변경, 키워드 Enter 시에도 호출)
    // 부서명(companyName)은 options.js 의 loadFieldList 에서 metaKey=com_name 검색 조건으로 변환된다.
    handleSearch() {
      this.$emit("search", {
        keyword: this.keyword,
        companyName: this.companyName,
        targetYear: this.targetYear === '전체' ? '' : this.targetYear
      })
    },
  }
}
</script>

<style scoped>

</style>
